import enFlag from '../../assets/images/flags/en.png';
import esFlag from '../../assets/images/flags/es.png';
import frFlag from '../../assets/images/flags/fr.png';
import ptBRFlag from '../../assets/images/flags/pt-BR.png';
import ptFlag from '../../assets/images/flags/pt.png';

function parseLanguageFlag(language) {
  switch (language?.tag) {
    case 'en':
      return enFlag;
    case 'pt':
      return ptFlag;
    case 'pt-BR':
      return ptBRFlag;
    case 'es':
      return esFlag;
    case 'fr':
      return frFlag;
    default:
      return '';
  }
}

export { parseLanguageFlag };
